(function() {
  'use strict';

  if (window.cometExclusivePopupInitialized) {
    var popupSection = document.querySelector('[data-comet-exclusive-popup]');
    if (popupSection && !popupSection.dataset.popupInitialized) {
      popupSection.dataset.popupInitialized = 'true';
      setTimeout(function() {
        if (typeof window.cometExclusivePopupShow === 'function') {
          window.cometExclusivePopupShow();
        }
      }, 300);
    }
    return;
  }

  window.cometExclusivePopupInitialized = true;

  function getModalId() {
    var popupSection = document.querySelector('[data-comet-exclusive-popup]');
    if (popupSection && popupSection.dataset.modalId) {
      return popupSection.dataset.modalId;
    }
    return 'comet-exclusive-popup-modal';
  }

  function shouldShowPopup() {
    return !document.body.hasAttribute('data-perplexity-comet');
  }

  window.cometExclusivePopupShow = function() {
    var modalId = getModalId();
    var modal = document.getElementById(modalId);
    if (!modal) return;

    if (typeof jQuery === 'undefined' || typeof jQuery.fn.modal === 'undefined') {
      setTimeout(showCometExclusivePopup, 100);
      return;
    }

    var attempts = 0;
    var maxAttempts = 20;
    
    function checkAndShow() {
      attempts++;
      
      if (shouldShowPopup() || attempts >= maxAttempts) {
        if (shouldShowPopup()) {
          var $modal = jQuery(modal);
          
          $modal.modal('hide');
          
          setTimeout(function() {
            $modal.modal({
              backdrop: 'static',
              keyboard: false
            });
            $modal.modal('show');
          }, 100);
        }
      } else {
        setTimeout(checkAndShow, 100);
      }
    }

    checkAndShow();
  };

  function showCometExclusivePopup() {
    window.cometExclusivePopupShow();
  }

  function initCometExclusivePopup() {
    var popupSection = document.querySelector('[data-comet-exclusive-popup]');
    if (!popupSection) return;
    
    showCometExclusivePopup();
  }

  function startInitialization() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(initCometExclusivePopup, 300);
      });
    } else {
      setTimeout(initCometExclusivePopup, 300);
    }
  }

  startInitialization();

  function handleNavigation() {
    setTimeout(function() {
      var popupSection = document.querySelector('[data-comet-exclusive-popup]');
      if (popupSection) {
        showCometExclusivePopup();
      }
    }, 800);
  }

  function setupTaxiListener() {
    var taxiInstance = null;
    
    if (typeof window.Taxi !== 'undefined') {
      taxiInstance = window.Taxi;
    } else if (typeof window.taxi !== 'undefined') {
      taxiInstance = window.taxi;
    }
    
    if (taxiInstance && typeof taxiInstance.on === 'function') {
      taxiInstance.on('NAVIGATE_END', function(event) {
        var view = null;
        if (event && event.to && event.to.content) {
          view = event.to.content.dataset ? event.to.content.dataset.taxiView : null;
        }
        
        if (view === 'product') {
          handleNavigation();
        }
      });
    }
    
    document.addEventListener('taxi:end', function(event) {
      if (event.detail && event.detail.view === 'product') {
        handleNavigation();
      }
    });
    
    var lastUrl = window.location.href;
    var checkInterval = setInterval(function() {
      var currentUrl = window.location.href;
      if (currentUrl !== lastUrl && currentUrl.includes('/products/')) {
        lastUrl = currentUrl;
        handleNavigation();
      }
    }, 500);
    
    setTimeout(function() {
      clearInterval(checkInterval);
    }, 30000);
  }

  setTimeout(setupTaxiListener, 1000);
  
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      var popupSection = document.querySelector('[data-comet-exclusive-popup]');
      if (popupSection && !popupSection.dataset.popupInitialized) {
        popupSection.dataset.popupInitialized = 'true';
        handleNavigation();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function isCometExclusiveBlocked() {
    var form = document.querySelector('[data-add-to-cart-form][data-comet-exclusive-blocked="true"]');
    return form !== null && !document.body.hasAttribute('data-perplexity-comet');
  }

  function createButtonOverlay() {
    if (!isCometExclusiveBlocked()) return;

    var addToCartBtn = document.querySelector('[data-add-to-cart-btn]:disabled');
    if (!addToCartBtn) return;

    var existingOverlay = addToCartBtn.querySelector('.comet-button-overlay');
    if (existingOverlay) return;

    var overlay = document.createElement('div');
    overlay.className = 'comet-button-overlay';
    overlay.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (typeof window.cometExclusivePopupShow === 'function') {
        window.cometExclusivePopupShow();
      }
      return false;
    });

    addToCartBtn.appendChild(overlay);
  }

  function setupBlockedElementsListeners() {
    if (typeof document.addEventListener === 'undefined') return;

    function handleBlockedClick(event) {
      if (isCometExclusiveBlocked()) {
        var target = event.target;
        var element = target;
        var isCometText = false;
        var isSelector = false;
        var isAddToCartBtn = false;
        
        while (element && element !== document.body) {
          if (element.classList && element.classList.contains('pdf-comet-text')) {
            isCometText = true;
            break;
          }
          if (element.classList && element.classList.contains('pdf-selectors')) {
            isSelector = true;
            break;
          }
          if (element.hasAttribute && element.hasAttribute('data-add-to-cart-btn')) {
            isAddToCartBtn = true;
            break;
          }
          element = element.parentElement;
        }
        
        if (isCometText || isSelector || isAddToCartBtn) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          if (typeof window.cometExclusivePopupShow === 'function') {
            window.cometExclusivePopupShow();
          }
          return false;
        }
      }
    }

    function handleFormSubmit(event) {
      if (isCometExclusiveBlocked()) {
        var form = event.target;
        if (form && form.hasAttribute && form.hasAttribute('data-add-to-cart-form')) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          if (typeof window.cometExclusivePopupShow === 'function') {
            window.cometExclusivePopupShow();
          }
          return false;
        }
      }
    }

    function attachListeners() {
      document.addEventListener('click', handleBlockedClick, true);
      document.addEventListener('submit', handleFormSubmit, true);
      createButtonOverlay();
    }

    function initOverlay() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          setTimeout(createButtonOverlay, 500);
        });
      } else {
        setTimeout(createButtonOverlay, 500);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachListeners);
    } else {
      attachListeners();
    }

    initOverlay();

    if (typeof MutationObserver !== 'undefined') {
      var overlayObserver = new MutationObserver(function() {
        createButtonOverlay();
      });
      
      overlayObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled']
      });
    }
  }

  setupBlockedElementsListeners();
})();

